import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 188px;
  width: 197px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral[4]};
  padding: ${({ theme }) => theme.spacing[5]}px;
  border-radius: ${({ theme }) => theme.radius[2]}px;
  gap: ${({ theme }) => theme.spacing[3]}px;
  align-items: center;
`;
